import articleToolTipIcon from '@/public/images/article-tool-tip.svg';
import articleToolTipInfoIcon from '@/public/images/tool-tip-info.svg';
import warningIcon from '@/public/images/warning.svg';
import {supportBasePath} from '@/utils/constants';
import {Article} from '@/utils/kms/article.types';
import {getPublicItem} from '@/utils/kms/get-public-item/route';
import {formatTitleForURL} from '@/utils/utils';
import {HtmlSanitizerBuilder, sanitizeHtml} from 'safevalues';

export function isToolTipComponent(htmlString: string) {
  return (
    htmlString?.toLowerCase()?.includes('tooltip-icon') ||
    htmlString?.toLowerCase()?.includes('tooltip - icon') ||
    htmlString?.toLowerCase()?.includes('tip-icon') ||
    htmlString?.toLowerCase()?.includes('tip - icon')
  );
}

export function isAlertComponent(htmlString: string) {
  return (
    htmlString?.toLowerCase()?.includes('alert-icon') ||
    htmlString?.toLowerCase()?.includes('alert - icon') // allowing space
  );
}

//check if article element having warning yellow or not
export function isWarningComponent(htmlString: string) {
  return (
    htmlString?.toLowerCase()?.includes('warning-icon') ||
    htmlString?.toLowerCase()?.includes('warning - icon') // allowing space
  );
}

//check if article element having info blue or not
export function isInfoComponent(htmlString: string) {
  return (
    htmlString?.toLowerCase()?.includes('info-icon') ||
    htmlString?.toLowerCase()?.includes('info - icon') // allowing space
  );
}

export function isContainsTooltipOrAlert(htmlString: string): boolean {
  return (
    isToolTipComponent(htmlString) ||
    isInfoComponent(htmlString) ||
    isAlertComponent(htmlString) ||
    isWarningComponent(htmlString)
  );
}

//get alert background to choose either warning or red

// // parse tool-tip content between <td> tags

// parse tool-tip content between <td> tags
export function getToolTipOrAlertContainedAnswer(htmlString: string) {
  try {
    // matching with tooltip-icon|tooltip - icon with case-insensitive
    let toolTipAlertString = htmlString;
    let htmlString2 = htmlString;
    const regX = /<table[^>]*>(.|\n)*?<\/table>/g;

    let matchNewLineInTable;
    // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
    while ((matchNewLineInTable = regX.exec(toolTipAlertString)) !== null) {
      const updatedString = matchNewLineInTable[0]
        .replaceAll('<br />\n<', '<')
        .replaceAll('>\n<', '><');
      toolTipAlertString = toolTipAlertString.replace(
        matchNewLineInTable[0],
        updatedString,
      );
      htmlString2 = toolTipAlertString;
    }

    const toolTipAlertParseRegularExp =
      /<table[^>]*>\s*<tbody[^>]*?>?\s*<tr[^>]*?>\s*<td[^>]*>\s*(?:<(?:div|span|p)[^>]*>\s*)*(?:tooltip-icon|tooltip - icon|tip-icon|tip - icon|alert-icon|alert - icon|warning-icon|warning - icon|info-icon|info - icon).*\s*(?:<\/(?:div|span|p)>)*\s*(?:\s*<div[^>]*>\s*<\/div>)*\s*<\/td>\s*<td[^>]*>\s*([\s\S]*?)<\/td>\s*<\/tr>\s*<\/tbody>\s*<\/table>\s*/gim;

    const matchers: string[] = [];
    const groupValues: string[] = [];
    // biome-ignore lint/suspicious/noImplicitAnyLet: <explanation>

    let match;
    // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
    while ((match = toolTipAlertParseRegularExp.exec(htmlString2)) !== null) {
      // Extract the src value
      if (match.length > 1) {
        matchers.push(match[0]);
        groupValues.push(match[1]);
      }
    }
    matchers.map((matchText, index: number) => {
      //const bgColor = getTooltipOrAlertBackgroundColor(matchText);
      if (
        isToolTipComponent(matchText)
        // (|| or && ) if we need to maintain kms api bg color
        // bgColor.toLowerCase() === TOOLTIP_AND_ALERTS_KMS_BG_COLORS.TOOLTIP_BACK_GROUND_COLOR.toLowerCase()
      ) {
        //Gray tool-tip
        const articleToolTip = `<article-tool-tip><img src=${articleToolTipIcon.src} alt="tool-tip"/><div>${groupValues?.[index]}</div></article-tool-tip>`;
        toolTipAlertString = toolTipAlertString.replace(
          matchText,
          articleToolTip,
        );
      } else if (
        isInfoComponent(matchText)
        // (|| or && ) if we need to maintain kms api bg color
        // bgColor.toLowerCase() ===
        //   TOOLTIP_AND_ALERTS_KMS_BG_COLORS.TOOLTIP_INFO_BACK_GROUND_COLOR.toLowerCase()
      ) {
        // blue tool-tip
        const articleToolTip = `<article-tool-tip-info><img src=${articleToolTipInfoIcon.src} alt="tool-tip-info"/><div>${groupValues?.[index]}</div></article-tool-tip-info>`;
        toolTipAlertString = toolTipAlertString.replace(
          matchText,
          articleToolTip,
        );
      } else if (
        isAlertComponent(matchText)
        // (|| or && ) if we need to maintain kms api bg color
        // bgColor.toLowerCase() ===
        // TOOLTIP_AND_ALERTS_KMS_BG_COLORS.ALERT_BACK_GROUND_COLOR.toLowerCase()
      ) {
        //red alert
        const articleToolTip = `<article-alert-red><img src=${warningIcon.src} alt="alert-red"/><div>${groupValues?.[index]}</div></article-alert-red>`;
        toolTipAlertString = toolTipAlertString.replace(
          matchText,
          articleToolTip,
        );
      } else if (
        isWarningComponent(matchText)
        // (|| or && ) if we need to maintain kms api bg color
        // bgColor.toLowerCase() ===
        // TOOLTIP_AND_ALERTS_KMS_BG_COLORS.WARNING_BACK_GROUND_COLOR.toLowerCase()
      ) {
        //yellow warning
        const articleToolTip = `<article-alert-warning><img src=${warningIcon.src} alt="alert-warning"/><div>${groupValues?.[index]}</div></article-alert-warning>`;
        toolTipAlertString = toolTipAlertString.replace(
          matchText,
          articleToolTip,
        );
      } else {
        // default creating INFO blue tool-tip
        const articleToolTip = `<article-tool-tip-info><img src=${articleToolTipIcon.src} alt="tool-tip"/><div>${groupValues?.[index]}</div></article-tool-tip-info>`;
        toolTipAlertString = toolTipAlertString.replace(
          matchText,
          articleToolTip,
        );
      }
    });

    return toolTipAlertString;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return htmlString;
  }
}

export const ARTICLE_ANSWER_ITEM_TYPES = [
  'T_HOW_TO',
  'GLOSSARY_TERM',
  'T_SERVICE_PRODUCT',
  'T_INTERNAL_SERVICE_PRODUCT',
  'T_TIPS_AND_TRICKS',
  'BRIEF',
  'T_SNIPPET',
  'INTERNAL',
];

export function getItemType(type: string) {
  if (ARTICLE_ANSWER_ITEM_TYPES.indexOf(type?.toUpperCase()) > -1) {
    return 'answer'; // for article details route
  }
  if (
    type?.toUpperCase().includes('FOLDER') ||
    type?.toUpperCase().includes('LIST')
  ) {
    return 'topic'; // for topic route
  }
  if (type?.toUpperCase().includes('SCENARIO')) {
    return 'troubleshooter'; // for troubleshooter route
  }
  //default case answer instead of undefined
  return 'answer';
}

async function updateHrefAttributeUrls(
  htmlString: string,
  locale: string,
): Promise<string> {
  const slugEnable = process.env.NEXT_PUBLIC_FEATURE_FLAG_SLUG_ENABLE;
  let updatedHrefUrlsHtml = htmlString;
  try {
    const anchorTagHrefUrlsRegularExp =
      /<a[^>]*href=["|']?([^"']+)["|']?[^>]*>(?:.*?)<\/a>/gim;
    const hrefMatchers: string[] = [];
    const hrefGroupValues: string[] = [];
    // biome-ignore lint/suspicious/noImplicitAnyLet: <explanation>
    let match;
    // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
    while ((match = anchorTagHrefUrlsRegularExp.exec(htmlString)) !== null) {
      // Extract the src value
      if (match?.length > 1) {
        hrefMatchers.push(match[0]);
        hrefGroupValues.push(match[1]);
      }
    }
    let index = 0;
    for (const matchText of hrefMatchers) {
      if (
        !matchText?.includes('https://') &&
        matchText?.toLowerCase()?.includes('/kms/')
      ) {
        //https://dummy added to make valid url to handle invalid url exception for crete new URL() to get path and query params dynamically
        let decodeUrl = decodeURIComponent(
          `https://dummy${hrefGroupValues?.[index].toString()}`,
        );
        //explicitly converting &#61; and &amp; characters to = and &
        decodeUrl = decodeUrl?.replace(/&#61;/g, '=')?.replace(/&amp;/g, '&');
        const url = new URL(decodeUrl);
        const extractedId: any =
          hrefGroupValues?.[index]?.match(/\/item\/(\d+)\//);
        const itemId = url?.searchParams?.get('item_id')
          ? url?.searchParams?.get('item_id')
          : (extractedId[1] ?? '');
        const pathnameParts = url?.pathname?.split('/');
        const serviceSegment = pathnameParts?.[3] ?? ''; //assuming type always in 4th index
        const type = getItemType(serviceSegment);

        if (itemId && type) {
          if (slugEnable === 'true') {
            const articleItem: Article = await getPublicItem(itemId, 'en');
            const articleTitle = formatTitleForURL(articleItem?.title);
            const updateHrefUrl = `${supportBasePath}/${locale}/${type}/${itemId}/${articleTitle}`;
            updatedHrefUrlsHtml = updatedHrefUrlsHtml.replace(
              hrefGroupValues?.[index],
              updateHrefUrl,
            );
          } else {
            const updateHrefUrl = `${supportBasePath}/${locale}/${type}/${itemId}`;
            updatedHrefUrlsHtml = updatedHrefUrlsHtml.replace(
              hrefGroupValues?.[index],
              updateHrefUrl,
            );
          }
        }
      }
      index++;
    }
    return updatedHrefUrlsHtml;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return updatedHrefUrlsHtml;
  }
}

export async function getTrustedTooltipItem(
  htmlString: string,
  locale: string,
): Promise<TrustedHTML> {
  let sanitizedHtmlString: string = htmlString;
  sanitizedHtmlString = await updateHrefAttributeUrls(
    sanitizedHtmlString?.toString(),
    locale,
  );
  //update href tag url to help-center urls for <a> and <img>
  //tool-tip
  if (isContainsTooltipOrAlert(htmlString.toString())) {
    const toolTipContainsAnswer = getToolTipOrAlertContainedAnswer(
      sanitizedHtmlString.toString(),
    );
    const sanitizer = new HtmlSanitizerBuilder()
      .allowCustomElement('article-tool-tip')
      .allowCustomElement('article-tool-tip-info')
      .allowCustomElement('article-alert-warning')
      .allowCustomElement('article-alert-red')
      .build();
    const sanitizedAnswer: TrustedHTML = sanitizer.sanitize(
      toolTipContainsAnswer.toString(),
    );
    return sanitizedAnswer;
  }
  return sanitizeHtml(sanitizedHtmlString.toString());
}
